function ViewManager(container)
{
    this.container = container;
    this.routing = container.get('routing');
    this.templating = container.get('templating');
    this.i18n = container.get('i18n');
    this.ga = container.get('google.analytics');
    this.views = [];
    this.defaultLang = 'unknown';
}

ViewManager.prototype.onRouteMatch = function(urlParams)
{
    Date.format.lang = this.i18n.lang;

    var templating = this.templating;
    templating.addGlobal('now', new Date());
    templating.addGlobal('get', urlParams);
    templating.addGlobal('_lang', this.i18n.lang);
    templating.addGlobal('_route', urlParams._route);
    
    var ga = this.ga;
    
    if (typeof urlParams._view !== 'undefined' && this.views[urlParams._view]) {
        var view = this.views[urlParams._view];
        
        if (view.handleRequest) {
            view.handleRequest(urlParams, function(name, context)
            {
                $('#page').html(templating.render(name, context));
                $('#loading').hide(); // no more loading
                ga.pageview(name, location.pathname + location.hash);
            });
        }
    }
};

ViewManager.prototype.onRouteBypassed = function()
{
    Date.format.lang = this.i18n.lang;

    var templating = this.templating;
    templating.addGlobal('_lang', this.i18n.lang);
    templating.addGlobal('_route', 'index');
    
    $('#page').html(templating.render('error.html', { error_text: 'error.404' }));
    $('#loading').hide(); // no more loading
};

ViewManager.prototype.start = function()
{
    this.container.get('dispatcher')
        //.addListener('i18n.language_changed', this, 'onLangChange')
        .addListener('routing.route_match', this, 'onRouteMatch')
        .addListener('routing.route_bypassed', this, 'onRouteBypassed')
    ;
    
    var that = this,
        routing = this.routing,
        templating = this.templating,
        i18n = this.i18n,
        views = this.views,
        sc = this.container,
        svcs = this.container.getByTag('view');

    // initialize views
    $.each(svcs, function(i, svc)
    {
        var routes = svc.getRoutes();
        
        $.each(routes, function(j, route)
        {
            route.defaults = route.defaults||{};
            route.defaults._view = i;
            route.defaults.lang = that.defaultLang; //function(){ return i18n.lang; };
            
            route.rules = route.rules||{};
            route.rules.lang = i18n.supportedLangs;
            
            routing.addRoute(route);
        });
        
        views[i] = svc;
    });
};
